import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken, getToken, formatApiErrorDetail } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = unauth, object = authed
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!getToken()) {
        setAdmin(false);
        setReady(true);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        setAdmin(data);
      } catch {
        clearToken();
        setAdmin(false);
      } finally {
        setReady(true);
      }
    };
    check();
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      setAdmin(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    clearToken();
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, ready, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
